module.exports = __webpack_public_path__ + "img/sec2.2.57376498.png";